"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Image_Click: "Click image",
            },
        });
        /**
         * Framework base class for Image controls
         */
        var Image = /** @class */ (function (_super) {
            __extends(Image, _super);
            function Image() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Image.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                $dyn.observe(this.Value, function (newValue) {
                    _this._value = newValue;
                    var imageType = "";
                    var imageName = "";
                    var tooltip = "";
                    var items = [];
                    // We get the container as a dictionary from the server with
                    // Items as the key and the actual contents as an array.
                    if (newValue && newValue.Items) {
                        if (newValue.Items instanceof Array) {
                            items = newValue.Items;
                        }
                        else if (newValue.Items.$values instanceof Array) {
                            items = newValue.Items.$values;
                        }
                        // tslint:disable-next-line:triple-equals
                        if (items.length === 4 && items[0] == 2) {
                            imageType = items[1];
                            imageName = items[2];
                            tooltip = items[3];
                            // tslint:disable-next-line:triple-equals
                        }
                        else if (items.length === 3 && items[0] == 1) {
                            imageType = items[1];
                            imageName = items[2];
                        }
                        else if (items.length === 1) {
                            // If image is stored as binary data, then the container
                            // contains only the image data and hence special case
                            // for it.
                            imageType = $dyn.ui.ImageType.base64;
                            imageName = items[0];
                        }
                    }
                    _this.ImageType(imageType);
                    _this.ImageName(imageName);
                    _this.Tooltip(tooltip);
                });
            };
            /**
             * The click event handler
             */
            Image.prototype.clicked = function (evt) {
                $dyn.applyFunction(this.Click, this);
            };
            /**
             * The keydown event handler
             * @param evt The keydown event
             */
            Image.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            /**
             * Get the sizing properties for the image
             * @returns An object describing the height and width properties of the image
             */
            Image.prototype.imageSizing = function () {
                if (this.isInGrid()) {
                    // When the image is in a grid, we will respect the sizing on the outer div.
                    // The inner div will be SizeToContent and will always have a fixed size so the image size remains constant.
                    // This is so that grid columns can still be resized, but the image itself will not be resized.
                    return { height: this.LayoutHeight, width: this.LayoutWidth };
                }
                else {
                    // When the image is outside of a grid, the inner div should provide the sizing in most cases.
                    // When the modeled width/height is SizeToAvailable, set the outer div width/height be SizeToAvailable, otherwise, it should always be SizeToContent.
                    return {
                        height: $dyn.value(this.Height) === $dyn.layout.Size.available ? $dyn.layout.Size.available : $dyn.layout.Size.content,
                        width: $dyn.value(this.Width) === $dyn.layout.Size.available ? $dyn.layout.Size.available : $dyn.layout.Size.content
                    };
                }
            };
            /**
             * Update the Control with ClientState
             * @param clientState clientState object
             * @param skipSetValue skips set value call when this is true
             */
            Image.prototype.ApplyState = function (clientState, skipSetValue) {
                if (skipSetValue === void 0) { skipSetValue = false; }
                if (clientState.clicked && !skipSetValue) {
                    this.clicked();
                }
            };
            return Image;
        }($dyn.ui.Control));
        controls.Image = Image;
        Image.prototype.IsImage = true;
        Image.prototype.ShowLabel = true;
        Image.prototype.Label = "";
        Image.prototype.Click = null;
        Image.prototype.SupportsDefaultAction = false;
        // tslint:disable:object-literal-sort-keys
        var imageShortcuts = {
            EnhancedPreview: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function (evt) {
                    return $dyn.shell.previewManager.enhancedPreviewShortcutHandler(this, evt);
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) ? true : false; },
                Description: $dyn.label("Input_OpenEnhancedPreview")
            },
            KeyboardClick: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.spacebar, $dyn.ui.KeyCodes.enter] },
                Handler: function () {
                    $dyn.applyFunction(this.Click, this);
                },
                Description: $dyn.label("Image_Click")
            }
        };
        Image.prototype.Shortcuts = $dyn.extendPrototype(Image.prototype.Shortcuts, imageShortcuts);
        $dyn.ui.addObservablePropertiesToPrototype(Image.prototype, {
            ImageType: "",
            ImageName: "",
            Tooltip: "",
            Value: null,
        });
        /**
         * Framework class for ImageCell controls
         */
        var ImageCell = /** @class */ (function (_super) {
            __extends(ImageCell, _super);
            function ImageCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.cellClicked = false;
                return _this;
            }
            ImageCell.prototype.queueClickCell = function () {
                this.cellClicked = true;
                this.validating = true;
                this.RaiseEvent($dyn.ui.ReadOnlyEvent, {
                    bubbles: true,
                });
            };
            ImageCell.prototype.ResetState = function () {
                this.cellClicked = false;
            };
            ImageCell.prototype.GetState = function () {
                return {
                    clicked: this.cellClicked,
                };
            };
            return ImageCell;
        }(Image));
        controls.ImageCell = ImageCell;
        $dyn.cellAdapter({ id: "Image" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Image.js.map
